import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PageContentWrapper } from '../main/LayoutStyles';
import {
    DetailWrapper, CaseHeader, StatusGrid, InfoBox, TimelineWrapper, CommentCard, AddCommentWrapper
} from './ReportDetailStyles';
import { AlertBox, StyledButton } from '../main/CommonStyles';
import { Loader2, AlertTriangle, Send, ArrowLeft } from 'lucide-react';
import apiClient from '../services/api';
import { useAuth } from '../auth/AuthContext';

const ReportDetailView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    const [reportCase, setReportCase] = useState(null);
    const [newMessage, setNewMessage] = useState('');
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [error, setError] = useState('');
    const commentsEndRef = useRef(null);

    useEffect(() => {
        const fetchReportDetails = async () => {
            setLoading(true);
            try {
                // POPRAWKA: Używamy nowego, poprawnego endpointu
                const response = await apiClient.get(`/cases/${id}`);
                setReportCase(response.data);
            } catch (err) {
                setError(err.response?.data?.message || 'Nie udało się załadować szczegółów sprawy.');
            } finally {
                setLoading(false);
            }
        };
        fetchReportDetails();
    }, [id]);

    const handleAddComment = async () => {
        if (newMessage.trim() === '') return;
        setSending(true);
        try {
            // POPRAWKA: Używamy nowego, poprawnego endpointu
            const response = await apiClient.post(`/cases/${id}/comments`, { content: newMessage });
            setReportCase(response.data); // Aktualizujemy całą sprawę na podstawie odpowiedzi z serwera
            setNewMessage('');
        } catch (err) {
            setError(err.response?.data?.message || 'Nie udało się wysłać komentarza.');
        } finally {
            setSending(false);
        }
    };

    useEffect(() => {
        commentsEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [reportCase]);

    if (loading) return <PageContentWrapper><div style={{textAlign: 'center'}}><Loader2 className="icon-spin" /> Ładowanie...</div></PageContentWrapper>;
    if (error) return <PageContentWrapper><AlertBox type="error"><AlertTriangle /> {error}</AlertBox></PageContentWrapper>;
    if (!reportCase) return null;

    return (
        <PageContentWrapper className="custom-scrollbar">
            <DetailWrapper>
                <StyledButton $variant="outline" onClick={() => navigate('/app/my-reports')} style={{marginBottom: '1.5rem', alignSelf: 'flex-start'}}>
                    <ArrowLeft size={16}/> Wróć do listy spraw
                </StyledButton>

                <CaseHeader>
                    <h2>{reportCase.title}</h2>
                    <StatusGrid>
                        <InfoBox>
                            <span className="label">Status Sprawy</span>
                            <span className="value">{reportCase.status || 'NOWE'}</span>
                        </InfoBox>
                        <InfoBox>
                            <span className="label">Zgłoszono do</span>
                            <span className="value">{reportCase.assigneeUsername || 'Brak'}</span>
                        </InfoBox>
                        <InfoBox>
                            <span className="label">Data Zgłoszenia</span>
                            <span className="value">{new Date(reportCase.createdAt).toLocaleDateString('pl-PL')}</span>
                        </InfoBox>
                    </StatusGrid>
                </CaseHeader>

                <TimelineWrapper>
                    {reportCase.comments.map((comment) => (
                        <CommentCard key={comment.id} $isOwn={comment.authorUsername === currentUser?.username}>
                            <div className="comment-header">
                                <span className="author">{comment.authorUsername === currentUser?.username ? "Ty napisałeś/aś:" : `Odpowiedź od: ${comment.authorUsername}`}</span>
                                <span className="timestamp">{new Date(comment.timestamp).toLocaleString('pl-PL')}</span>
                            </div>
                            <p className="content">{comment.content}</p>
                        </CommentCard>
                    ))}
                    <div ref={commentsEndRef} />
                </TimelineWrapper>

                <AddCommentWrapper>
                    <h3>Dodaj nowy komentarz lub informację</h3>
                    <textarea
                        placeholder="Jeśli chcesz coś dodać, opisz to tutaj..."
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        disabled={sending}
                    />
                    <StyledButton onClick={handleAddComment} disabled={sending || !newMessage.trim()}>
                        {sending ? <Loader2 className="icon-spin" size={18}/> : <Send size={18} />}
                        Wyślij
                    </StyledButton>
                </AddCommentWrapper>

            </DetailWrapper>
        </PageContentWrapper>
    );
};

export default ReportDetailView;